"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  id: 1,
  src: "https://sure-fly.10web.cloud/wp-content/uploads/2026/01/Marinara.remini-enhanced.png",
  name: "Marinara"
}, {
  id: 2,
  src: "https://sure-fly.10web.cloud/wp-content/uploads/2026/01/Verdechiosa.remini-enhanced.png",
  name: "Verdechiosa"
}, {
  id: 3,
  src: "https://sure-fly.10web.cloud/wp-content/uploads/2026/01/Margherita.remini-enhanced.png",
  name: "Margherita"
}, {
  id: 4,
  src: "https://sure-fly.10web.cloud/wp-content/uploads/2026/01/Rossochiosa.remini-enhanced-1.png",
  name: "Rossochiosa"
}, {
  id: 5,
  src: "https://sure-fly.10web.cloud/wp-content/uploads/2026/01/Pera.remini-enhanced.png",
  name: "Pera"
}, {
  id: 6,
  src: "https://sure-fly.10web.cloud/wp-content/uploads/2026/01/Forestella.remini-enhanced.png",
  name: "Forestella"
}, {
  id: 7,
  src: "https://sure-fly.10web.cloud/wp-content/uploads/2026/01/Stella-dolce.remini-enhanced.png",
  name: "Stella dolce"
}, {
  id: 8,
  src: "https://sure-fly.10web.cloud/wp-content/uploads/2026/01/Pistacchiosa.remini-enhanced.png",
  name: "Pistacchiosa"
}];
function ImageCard({
  src,
  name
}: {
  src: string;
  name: string;
}) {
  return <div className="group relative aspect-square overflow-hidden rounded-xl shadow-soft">
      <img src={src} alt={name} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-colors" />

      {/* Name – Leiste unten, nur bei Hover */}
      <div className="absolute left-0 right-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out">
        <div className="bg-black/60 backdrop-blur-sm px-4 py-3">
          <p className="text-white font-semibold text-lg text-center">
            {name}
          </p>
        </div>
      </div>
    </div>;
}
function VideoCard({
  src,
  poster
}: {
  src: string;
  poster: string;
}) {
  return <div className="w-full max-w-md rounded-xl overflow-hidden bg-black shadow-soft">
      <video src={src} poster={poster} className="w-full h-full object-cover" controls preload="metadata" playsInline />
    </div>;
}
export default function Galerie() {
  const {
    ref
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return;
}